import { ButtonGroup, Grid, Stack, Typography } from "@mui/material"
import { useContext } from "react"
import { useTranslation } from "react-i18next"
import { OrganisationContext } from "../components/Layout/OrganisationPicker"
import Loading from "../components/loading"
import { PermissionEnum } from "../feature/Permission/PermissionEnum"
import { CreateServiceAccountButton } from "../feature/UserApi/CreateServiceAccountButton"
import { CreateUserButton } from "../feature/UserApi/CreateUserButton"
import { AbilityContext } from "../feature/UserApi/logic/Can"
import { UserContext } from "../feature/UserApi/logic/FetchUser"
import { useGetAllUserQuery, useGetAllUsersByOrganisationQuery } from "../feature/UserApi/redux/userApiSlice"
import { UserList } from "../feature/UserApi/usersList"

export const UserPage = () => {
    const { t } = useTranslation()
    const currentOrganisation = useContext(OrganisationContext)?.organisation;
    const userContext = useContext(UserContext);
    const ability = useContext(AbilityContext);

    if (!currentOrganisation && !userContext?.allowEmptyOrganisation())
        return <Loading />

    return (

        <Grid container spacing={5}>
            <Grid item xs={6}>
                <Stack direction="row" spacing={2}>
                    <Typography variant="h5">{t("Users") + ""}</Typography>
                    <ButtonGroup variant="text">
                        <CreateUserButton />
                        {ability.can(PermissionEnum.GOD, {}) && <CreateServiceAccountButton />}
                    </ButtonGroup>
                </Stack>
            </Grid>
            <Grid item xs={12}>
                <UserList idToFetch={currentOrganisation?.uuid} getUsers={currentOrganisation ? useGetAllUsersByOrganisationQuery : useGetAllUserQuery} />
            </Grid>
        </Grid>

    )
}